/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { overdueInvoiceActions } from "../../../state/pendingInvoices";
import { IOverdueInvoiceOverallInfo, IOverdueInvoicePetInfo } from "../../../state/pendingInvoices/pendingInvoices.reducer";

export const useOverdueInvoiceStore = () => {
  const dispatch = useDispatch();
  const {
    pausedWellnessPetList,
    overdueWellnessPetList,
    cancelledWellnessPetList,
    pendingPaymentPetList,
    scratchpayOverdueNoticePetIds,
    isOverdueStoreUpdated,
    cancelledPetListWithoutOverdue,
  } = useSelector((state: IRootState) => state.overdueInvoiceData) as {
    pausedWellnessPetList: IOverdueInvoicePetInfo[];
    overdueWellnessPetList: IOverdueInvoicePetInfo[];
    cancelledWellnessPetList: IOverdueInvoicePetInfo[];
    pendingPaymentPetList: IOverdueInvoiceOverallInfo[];
    cancelledPetListWithoutOverdue: IOverdueInvoicePetInfo[];
    scratchpayOverdueNoticePetIds: string[];
    isOverdueStoreUpdated: boolean;
  };

  const setCancelledPetList = (data: IOverdueInvoicePetInfo[]) => {
    dispatch(overdueInvoiceActions.setCancelledPetList(data));
  };
  const setPausedPetList = (data: IOverdueInvoicePetInfo[]) => {
    dispatch(overdueInvoiceActions.setPausedPetList(data));
  };
  const setOverduePetList = (data: IOverdueInvoicePetInfo[]) => {
    dispatch(overdueInvoiceActions.setOverduePetList(data));
  };
  const setPendingPaymentPetList = (data: IOverdueInvoiceOverallInfo[]) => {
    dispatch(overdueInvoiceActions.setPendingPaymentPetList(data));
  };
  const setScratchpayOverdueNoticePetIds = (data: string[]) => {
    dispatch(overdueInvoiceActions.setScratchpayOverdueNoticePetIds(data));
  };
  const setIsOverdueStoreUpdated = (data: boolean) => {
    dispatch(overdueInvoiceActions.setIsOverdueStoreUpdated(data));
  };
  const resetOverdueStore = () => {
    dispatch(overdueInvoiceActions.resetOverdueStore());
  };

  const setCancelledPetListWithoutOverdue = (data: IOverdueInvoicePetInfo[]) => {
    dispatch(overdueInvoiceActions.setCancelledPetListWithoutOverdue(data));
  };


  return {
    pausedWellnessPetList,
    overdueWellnessPetList,
    cancelledWellnessPetList,
    pendingPaymentPetList,
    scratchpayOverdueNoticePetIds,
    isOverdueStoreUpdated,
    cancelledPetListWithoutOverdue,
    setCancelledPetList,
    setPausedPetList,
    setOverduePetList,
    setPendingPaymentPetList,
    setScratchpayOverdueNoticePetIds,
    setIsOverdueStoreUpdated,
    resetOverdueStore,
    setCancelledPetListWithoutOverdue,
    isBookingBlocked: false,
    // use the below code incase locking of booking CTAs is required
    // isBookingBlocked: !isOverdueStoreUpdated ||
    // ((pausedWellnessPetList.length > 0 ||cancelledWellnessPetList.length > 0)),
  };
};
